import { type Locale } from 'contexts/LocaleContext/locales';
import { getTextDirection } from './textDirection';

export const isRtl = (locale: Locale) => getTextDirection(locale) === 'rtl';
